module.exports = __webpack_public_path__ + "img/backyard-bushes.83649913.webp";